// removed by extract-text-webpack-plugin
module.exports = {"flexPosition":"_3ngiivyz328ovCWd-IRnx-","userData":"_3dySA0S5I4-sr4_POUz-5Q","packageName":"_1LMVIn4eltsp4tOfdZ5t-m","validUntilWrapper":"_2dng-fVJTyppKlInoS7geh","topBlockText":"_1A3yNeZIw5nVDwqczK2lDK","days":"_2fG0-X0w2IXvFUu2yDUQT3","remainingProps":"_3tiOMPq0tKF5-aSHHaUV0W","boldText":"_3CKMeBcEYhHE2p2ndQPJES","updateBtn":"_2LfWnCdHO66KObkxXpxbR1","updateBtnText":"_3EB6GxxJKBI4iYPtaTzZcc","packagePromotion":"_1-A8unnKugZ9x6qVuFsu_y","packagePromotionLabel":"_1U04zO7pAQVXSCQYgNT3zm","counter":"_2CIJFyLLumMkuARft7Msls"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyStaffContainer/components/MyProperiesBlock/MyPropertiesBlock.scss
// module id = 1849
// module chunks = 0